module.exports = __webpack_public_path__ + "static/media/hazel-not-selected.ff38da0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tags/hazel-not-selected.svg
// module id = 65
// module chunks = 0